module.exports = __webpack_public_path__ + "static/media/phone_icon.df6a5cbd.svg";